<template>
  <ul class="custom-breadcrumbs breadcrumb">
    <template v-if="$route.meta.parentRoutes && $route.meta.parentRoutes.length" >
      <li
        v-for="(parentRoute, i) in $route.meta.parentRoutes"
        :key="i">
        <router-link :to="{ name: parentRoute.name }" v-if="parentRoute.name!=='Playbook'">
          <span>
            {{parentRoute.displayText}}
          </span>
        </router-link>
        <span class="text-uppercase" v-if="parentRoute.name==='Playbook'">
          {{$t('BREADCRUMB.playbook')}}
        </span>
      </li>
    </template>
    <li class="active">
      <template v-if="!$route.meta.bcDynamic" :to="{name: $route.name}">
        <span>
          {{bcLinkTextTrans}}
        </span>
      </template>
      <template
        v-if="$route.meta.bcDynamic"
        :to="{ name: $route.name, params: { id: $route.params.id }}">
        <span v-if="value">
          {{formattedValue === 'CALENDAR_ACTIVITY.team' ? $t('CALENDAR_ACTIVITY.team') : $t('CALENDAR_ACTIVITY.individual') }}
        </span>
        <span v-if="!value">
          {{loadingText}}
        </span>
      </template>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: [
    'route'
  ],
  beforeCreate () {
    this.$options.computed.value = function () {
      if (this.$route.meta.bcGetter) {
        return this.$store.getters[this.$route.meta.bcGetter]
        
      } else {
        return null
        this.$route.meta.bcLinkText = this.bcLinkTextTrans()
      }
    }
      
  },
  mounted() {
    
  },
  computed: {
    formattedValue () {
      return this.$route.meta.bcLinkText(this.value)
    },
    loadingText () {
      const loadingText = this.$route.meta.bcLoadingText
      return loadingText || 'Loading...'
    },
    bcLinkTextTrans() {
      switch(this.$route.meta.bcLinkText) {
        case "Profile":
          return this.$t('BREADCRUMB.profile')
          break;
        case "Dashboard" :
          return this.$t('BREADCRUMB.dashboard')
          break;
        case "Calendar":
          return this.$t('BREADCRUMB.calendar')
        case "Shop":
          return this.$t('BREADCRUMB.shop')
          break;
        case "Session History":
          return this.$t('BREADCRUMB.sessionHistory')
          break;
        case "Playbook":
          return this.$t('BREADCRUMB.playbook')
          break;
        case "Getting Started":
          return this.$t('BREADCRUMB.gettingStarted')
          break;
        case "Reading Data":
          return this.$t('BREADCRUMB.readingData')
          break;
        case "Doing More":
          return this.$t('BREADCRUMB.doingMore')
          break;
        case "Troubleshooting":
          return this.$t('BREADCRUMB.troubleshooting')
        default:
          return this.$t('BREADCRUMB.calendar')
      }
    }
  },
}
</script>
